/* SchemaForm helper that resets a hidden field when a field it depends on changes */
import React, { useEffect, useRef } from "react";
import lodash from "lodash";
import { getShowInput } from "components/util/schema_form/util/schema_form";


// A shown DynamicSelectField checks its own value against its new options. One hidden by show_if
// is not mounted, so the value picked under the previous dependencies would reach the node unchecked.
const DependenciesObserver = ({ schema, parentKey, values, setFieldValue }) => {

  const previousValues = useRef({});
  const getKey = (name) => parentKey == "" ? name : `${parentKey}.${name}`
  const dependentInputs = schema.filter(input => (input.dynamic_dependencies ?? []).length > 0)
  const dependencyNames = lodash.uniq(dependentInputs.flatMap(input => input.dynamic_dependencies))

  useEffect(() => {
    const currentValues = Object.fromEntries(dependencyNames.map(name => [name, lodash.get(values, getKey(name))]))
    // An undefined previous value is the form still loading or a default being set, not a user change
    const hasChanged = (name) =>
      previousValues.current[name] !== undefined && !lodash.isEqual(previousValues.current[name], currentValues[name])

    dependentInputs
      .filter(input => !getShowInput(parentKey, input.show_if ?? [], values))
      .filter(input => input.dynamic_dependencies.some(hasChanged))
      .forEach(input => setFieldValue(getKey(input.name), input.default))
    previousValues.current = currentValues
  }, [values]); // eslint-disable-line react-hooks/exhaustive-deps

  return <div></div>;
};

export default DependenciesObserver;
